// hotels
import hotel1 from "../Images/Bookings/hotel1.jpg";
import hotel2 from "../Images/Bookings/hotel2.jpg";
import hotel3 from "../Images/Bookings/hotel3.jpg";
import hotel4 from "../Images/Bookings/hotel4.jpg";
import hotel5 from "../Images/Bookings/hotel5.jpg";
import hotel6 from "../Images/Bookings/hotel6.jpg";

const hotels = [
  {
    src: hotel1,
    cardtitle: "Make My Trip",
    cardtext: "Get best deals on hotels from Make My Trip",
    link: "https://www.makemytrip.com/hotels/mysore-hotels.html",
  },
  {
    src: hotel2,
    cardtitle: "Booking.com",
    cardtext: "Get best deals on hotels from Booking.com",
    link:
      "https://www.booking.com/city/in/mysore.en-gb.html?label=gen173nr-1DCAMobEIGbXlzb3JlSAlYBGhsiAEBmAEJuAEXyAEM2AED6AEBiAIBqAIDuALBos7-BcACAdICJDUyOWRkMjc1LWVkMWYtNDNkNC1iOTAxLWVmMWQ3Y2VhZjZjN9gCBOACAQ;sid=475458a855eaaa5d2d4c22214ffdd247;inac=0&keep_landing=1&",
  },
  {
    src: hotel3,
    cardtitle: "Trivago",
    cardtext: "Get best deals on hotels from Trivago",
    link:
      "https://www.trivago.in/en?themeId=1&iPathId=94410&sem_keyword=hotels%20in%20mysore&sem_creativeid=485457495262&sem_matchtype=e&sem_network=g&sem_device=c&sem_placement=&sem_target=&sem_adposition=&sem_param1=&sem_param2=&sem_campaignid=11541041494&sem_adgroupid=115458724754&sem_targetid=kwd-186658076&sem_location=20465&cip=9119000439&gclid=Cj0KCQiAzsz-BRCCARIsANotFgPEKRlMe2DdBihCqUTXIUfnMaliM6sDjiwOfqd_wsDtEuMHf65Yn5gaArqUEALw_wcB",
  },
  {
    src: hotel4,
    cardtitle: "Goibibo",
    cardtext: "Get best deals on hotels from Goibibo",
    link:
      "https://www.goibibo.com/hotels/find-hotels-in-Mysore/6237241643285427714/6237241643285427714/%7B%22d%22:%7B%22k%22:10%7D%7D/?sec=dom&utm_source=google&utm_medium=cpc&utm_campaign=Hotel_Destination_Mysore&utm_content=Mysore%20Hotels%20Generic&utm_term=Hotels%20in%20mysore&campaign=Hotel_Destination_Mysore&gclid=Cj0KCQiAzsz-BRCCARIsANotFgNsKoI4JMoNdZ3CG0d7KCcUBf21SJtuvY2fcJX0rc4QWckFid6elPgaAjHxEALw_wcB",
  },
  {
    src: hotel5,
    cardtitle: "OYO Rooms",
    cardtext: "Get best deals on hotels from OYO Rooms",
    link: "https://www.oyorooms.com/hotels-in-mysore/",
  },
  {
    src: hotel6,
    cardtitle: "Yatra",
    cardtext: "Get best deals on hotels from Yatra",
    link: "https://www.yatra.com/hotels/hotels-in-mysore",
  },
];

export default hotels;
